import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo } from 'react';
import CodebotsOauth2Service from '../Services/CodebotsOauth2Service';
import LocalStorage from '../Services/Persistence/LocalStorage';
import useConfiguration from './UseConfiguration';
import FetchClient from '@cb/common-ts/FetchClient';
const authServiceContext = React.createContext(undefined);
export default function useAuthService() {
    const authService = useContext(authServiceContext);
    if (!authService) {
        throw new Error('authService not found');
    }
    return authService;
}
export function AuthServiceProvider(props) {
    const { children } = props;
    const configuration = useConfiguration();
    const authService = useMemo(() => new CodebotsOauth2Service(new LocalStorage(), new FetchClient(), configuration), [configuration]);
    return _jsx(authServiceContext.Provider, { value: authService, children: children });
}
//# sourceMappingURL=UseAuthService.js.map